import * as S from "./NavigationBar.style";
import { NavList } from "@/components/molecules/NavList";
import { NavMenus } from "@/data/menus";
import { useRecoilValue } from "recoil";
import { loginTypeState } from "@/common/states/user";

export const NavigationBar = () => {
  const loginType = useRecoilValue(loginTypeState);

  return (
    <S.NavigationBar>
      <NavList
        data={loginType === "student" ? NavMenus[0].menus : NavMenus[1].menus}
      />
    </S.NavigationBar>
  );
};
